import React, { useState, useRef } from 'react'

const BannerTab = () => {
    const [selectedImages, setSelectedImages] = useState([])
    const ref=useRef(null)

    const handleDrop = (e) => {
        e.preventDefault()
        const images = Array.from(e.dataTransfer.files).filter((file) =>
            file.type.startsWith('image/')
        )
        if (images.length > 0 && images.length <= 5) {
            setSelectedImages([...selectedImages, ...images])
        }
        else {
          alert('Accept Only 5 Images')
        }
        e.dataTransfer.files=[] 
    }

    const handleFileInputChange = (e) => {
    
     console.log(e.target.files,"dddddd");


     
      const a = new Image()
           a.src = URL.createObjectURL(e.target.files[0]) 
          a.addEventListener("load",(e)=>{

              if(a.height <=1080 && a.height >= 1080){
                   alert("please select Image with height between < 830 and  > 1080")
                   
                if(a.width <=1080 && a.width >= 1080){
                  alert("please select Image with width between < 830 and  > 1080")                 
                }
              }
          })
        const images = Array.from(e.target.files).filter((file) =>
            file.type.startsWith('image/')
        )
        if (images.length > 0 && images.length <= 5) {
            setSelectedImages([...selectedImages, ...images])
        }
        else {
          alert('Accept Only 5 Images')
        }
        e.target.value="" 
    }

    const handleDragOver = (e) => {
        e.preventDefault() 
    }

    function validateFileType(e) {
   
        var fileName = document.getElementById('fileName').value
        var idxDot = fileName.lastIndexOf('.') + 1
        var extFile = fileName.substr(idxDot, fileName.length).toLowerCase()
        if (extFile == 'jpg' || extFile == 'jpeg' || extFile == 'png') {
        }
        else {
            alert('Only jpg/jpeg and png files are allowed!')
        }
      
    }

    function handleDragDropClick(){
      ref.current.click()
    }

    return (
        <div>
            <div className="admin-card">
                <div className="head">
                    <h2>Header Banner Management</h2>
                    <button type="button" className='solid-red-btn'>Save</button>
                </div>
                <div className="admin-form-body">
                    <div
                        onDrop={(e) => handleDrop(e)}
                        onDragOver={(e) => handleDragOver(e)}
                        onChange={(e) => validateFileType(e)}
                        onClick={()=>handleDragDropClick()}
                        style={{
                            width: 'auto',
                            height: '300px',
                            border: '1px dashed #aaa',
                            borderRadius: '5px',
                            marginBottom: '20px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                        }}
                    >
                        <p>Drop images here or click to select</p>
                    </div>
                    <input
                    ref={ref}
                        hidden
                        type="file"
                        accept="image/png, image/jpeg, image/jpg"
                        onChange={(e) => handleFileInputChange(e)}
                        multiple
                    />
                    {selectedImages.length > 0 && (
                        <div>
                            <h2>Selected Images:</h2>
                            <ul className="image-gallary">
                                {selectedImages.map((image, index) => (
                                  <React.Fragment key={index}>
                                    <li>
                                        <img
                                            src={URL.createObjectURL(image)}
                                            alt={`Image ${index}`}
                                        />
                                    </li>
                                  </React.Fragment>
                                ))}
                            </ul>
                        </div>
                    )}
                  
                </div>
            </div>
        </div>
    )
}

export default BannerTab
